export default __webpack_public_path__ + "static/media/bungalow-plattegrond.6aef46a8.png";